import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";

export default function SprintHistory() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/sprints/history"); setItems(data); }
      finally { setLoading(false); }
    })();
  }, []);

  return (
    <div data-testid="sprint-history-page" style={{ padding: "60px 6vw 100px", maxWidth: 1100, margin: "0 auto" }}>
      <div className="overline">§ Chronicle</div>
      <h1 className="font-serif" style={{ fontSize: "clamp(40px, 5vw, 58px)", lineHeight: 1, margin: "14px 0 8px" }}>
        Sprint <span className="font-display" style={{ color: "var(--brass)" }}>history</span>.
      </h1>
      <p className="font-serif" style={{ color: "var(--parchment-dim)", fontStyle: "italic", fontSize: 17, marginBottom: 40 }}>
        A chronological register of every rite of passage undertaken.
      </p>
      <div className="rule-parchment" style={{ marginBottom: 40 }} />

      {loading ? (
        <div className="font-mono" style={{ color: "var(--parchment-dim)", fontSize: 12 }}>Loading chronicle...</div>
      ) : items.length === 0 ? (
        <div style={{ border: "1px dashed rgba(197,160,89,0.35)", padding: 60, textAlign: "center" }}>
          <div className="font-display" style={{ fontSize: 44, color: "var(--brass)", fontStyle: "italic" }}>—</div>
          <div className="font-serif" style={{ fontSize: 22, marginTop: 10 }}>No sprints yet inscribed.</div>
        </div>
      ) : (
        <ol style={{ listStyle: "none", margin: 0, padding: 0, borderLeft: "1px solid rgba(197,160,89,0.28)" }}>
          {items.map((it, i) => (
            <li
              key={it.project_id}
              data-testid={`history-item-${it.project_id}`}
              className="reveal"
              style={{ padding: "22px 0 22px 32px", position: "relative", animationDelay: `${0.05 * i}s` }}
            >
              <span
                style={{
                  position: "absolute", left: -7, top: 30, width: 12, height: 12,
                  background: it.deployed ? "var(--brass)" : "var(--ink-surface)",
                  border: "1px solid var(--brass)",
                }}
              />
              <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 12 }}>
                <div>
                  <div className="overline">{new Date(it.created_at).toUTCString().slice(0, 16)} · Sprint {String(i + 1).padStart(2, "0")}</div>
                  <h3 className="font-serif" style={{ fontSize: 28, lineHeight: 1.1, margin: "6px 0" }}>{it.name}</h3>
                  <div className="font-display" style={{ color: "var(--muted)", fontSize: 13, fontStyle: "italic" }}>
                    Phase {it.phase}/5 · Model: {it.generation?.model || "—"} · Chaos:{" "}
                    <span style={{ color: it.chaos?.passed ? "var(--success)" : "var(--warning)" }}>
                      {it.chaos?.passed ? "PASS" : "—"}
                    </span>
                    {it.deployed && <> · <span style={{ color: "var(--brass)" }}>Deployed</span></>}
                  </div>
                </div>
                <Link to={`/sprint/${it.project_id}`} className="btn-ghost">Resume →</Link>
              </div>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
}
